
import React, { useState, useEffect } from 'react';
import HeatMapGrid from 'react-heatmap-grid';

const HeatMap = () => {
    const [containerWidth, setContainerWidth] = useState(window.innerWidth);

    const xLabels = [
        "add meta data",
        "add tags",
        "chit-chat",
        "get documents",
        "send email",
    ];
    const yLabels = ["add meta data", "add tags", "chit-chat", "get documents", "send email"];

    const data = [
        [9, 1, 0, 5, 0],
        [2, 11, 0, 0, 0],
        [1, 0, 10, 0, 3],
        [0, 0, 1, 14, 0],
        [0, 0, 1, 0, 13],
    ];

    useEffect(() => {
        const handleResize = () => setContainerWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const responsiveCellSize = Math.min(containerWidth / xLabels.length, 59); // Adjust max cell size if needed

    return (
        <div style={{ fontSize: "14px" }}>
            <HeatMapGrid 
                xLabels={xLabels.map((label) => (
                    <div style={{ fontSize: '14px', textAlign: 'center' }}>{label}</div>
                ))}
                yLabels={yLabels.map((label) => (
                    <div style={{ textAlign: 'left' }}>{label}</div>
                ))}
                data={data}
                cellRender={(x, _y, _value) => <div>{x}</div>}
                cellStyle={(_background, value, min, max, _data, _x, _y) => ({
                    background: `rgba(5, 45, 105, ${1 - (max - value) / (max - min)})`,
                    fontSize: "15px",
                    color: value > 10 ? "white" : "black",
                    textAlign: "center",
                    height: responsiveCellSize,
                    width: responsiveCellSize,
                    margin: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                })}
                yLabelWidth={150}
                xLabelsLocation={"bottom"}
                xLabelsStyle={{ color: 'blue', fontSize: '14px', fontWeight: 'bold' }}
            // Adjust grid width and height as needed for various screen sizes
            // (consider using CSS media queries or a dedicated layout library)
            />
        </div>
    );
};

export default HeatMap;